export default "__VITE_ASSET__rfD5qzGG__"